import * as React from "react"
import type { CSS } from "../stitches.config"
import Text from "./Text"

type HeadingProps = React.ComponentProps<"h1"> & { css?: CSS; as?: any }

export const H1 = React.forwardRef<React.ElementRef<"h1">, HeadingProps>(
    (props, forwardedRef) => {
        const { css, color, ref, ...textProps } = props
        return (
            <Text
                size="heading-06"
                as="h1"
                ref={forwardedRef}
                css={{ mb: "$2", lineHeight: "2.5rem", ...props.css }}
                {...textProps}
            />
        )
    }
)

export const H2 = React.forwardRef<React.ElementRef<"h2">, HeadingProps>(
    (props, forwardedRef) => {
        const { css, color, ref, ...textProps } = props
        return (
            <Text
                size="heading-05"
                as="h2"
                ref={forwardedRef}
                css={{ mb: "$2", lineHeight: "$9", ...props.css }}
                {...textProps}
            />
        )
    }
)

export const H3 = React.forwardRef<React.ElementRef<"h3">, HeadingProps>(
    (props, forwardedRef) => {
        const { css, color, ref, ...textProps } = props
        return (
            <Text
                size="heading-04"
                as="h3"
                ref={forwardedRef}
                css={{ mb: "$2", lineHeight: "$7", ...props.css }}
                {...textProps}
            />
        )
    }
)

export const H4 = React.forwardRef<React.ElementRef<"h4">, HeadingProps>(
    (props, forwardedRef) => {
        const { css, color, ref, ...textProps } = props
        return (
            <Text
                size="heading-03"
                as="h4"
                ref={forwardedRef}
                css={{ mb: "$2", lineHeight: "$6", ...props.css }}
                {...textProps}
            />
        )
    }
)
